// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + ({"805":"25f4ac2a","817":"f518e38b"}[chunkId] || chunkId) + "." + {"448":"437bcc169696f353","629":"63f5b09dee7e39aa","644":"a68d80de38e6d272","768":"7135e6aeaa9007ba","805":"0de419754430e75e","816":"d2fccf5f5ecbfffe","817":"ddc3ec96230226a6"}[chunkId] + ".js";
};